<div mat-dialog-title>
  <h1>Set user credentials</h1>
  <tp-modal-close-button />
</div>
<div class="tp-modal-content">
  <tp-scroll-container class="tp-modal-body" mat-dialog-content>
    <div class="tp-cluster-password-section">
      <p>
        Your cluster is being provisioned and will be ready soon! You'll need to set its admin user credentials.
        Use the pre-generated secure password below, or choose your own.
      </p>
      <tp-form-input matTooltip="Your username can be changed later" readonly [form]="passwordForm" field="username" label="Username"></tp-form-input>
      <tp-form-password-input [form]="passwordForm" field="password" label="Password">
        <button inputSuffix
          class="tp-cluster-password-regenerate" type="button" buttonId="regeneratePassword"
          [disabled]="isPasswordFormSubmitting$ | async" (click)="generatePassword(); $event.stopPropagation()"
        >
          <i class="fa-light fa-refresh"></i>
        </button>
      </tp-form-password-input>
    </div>
  </tp-scroll-container>

  <div class="tp-btn-section">
    <div class="flex-spacer"></div>
    <div class="btn-section-inner">
      <tp-button
        buttonId="downloadCredentials" buttonStyle="primary-outline green stroke"
        [enabled]="!(isPasswordFormSubmitting$ | async) && !!passwordForm.value.password && !credentialsDownloading"
        (click)="downloadCredentials()"
      >
        <div class="tp-download-credentials-content">
          Confirm and download credentials
        </div>
      </tp-button>
      <button (click)="submitPasswordForm(false)">Confirm without downloading →</button>
    </div>
  </div>
</div>
